module.exports = __webpack_public_path__ + "static/media/C010.255576a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/C010.jpg
// module id = 293
// module chunks = 0